module.exports = __webpack_public_path__ + "fonts/IRANYekanWebRegular.d2f8150.woff";